import React from 'react';
import { useSelector } from 'react-redux';

import { conditionIsEmpty } from '../../../../../../general/modules/filter/dataModel';
import { Column } from '../../../model';
import { getActiveFilters } from '../../../selectors/selectors';
import './label.scss';
const FilterIcon = () => (
  <svg
    className="ch-file-manager__filter-icon"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="ch-file-manager__filter-icon-inner"
      d="M.572.571h6.857v1.016L4.867 4.183 4.571 6.68l-1.142.572-.203-3.046L.572 1.587z"
      fill="transparent"
    />
    <path
      className="ch-file-manager__filter-icon-contour"
      d="M7.714 0H.286A.286.286 0 000 .286v1.428c0 .081.035.158.095.213l2.762 2.486v3.301a.286.286 0 00.414.256l1.714-.857a.286.286 0 00.158-.256V4.413l2.762-2.486A.286.286 0 008 1.714V.286A.286.286 0 007.714 0zM7.43 1.587L4.666 4.073a.286.286 0 00-.095.213V6.68l-1.142.572V4.286a.286.286 0 00-.095-.213L.572 1.587V.571h6.857v1.016z"
      fill="#303030"
    />
  </svg>
  // <svg viewBox="0 0 16 16" fill="none" className="ch-file-manager__filter-icon">
  //   <path d="M15.4284 0H0.571552C0.255955 0 0.00012207 0.255833 0.00012207 0.57143V3.42851C0.000155552 3.59043 0.0688932 3.74475 0.189259 3.85309L5.71432 8.82557V15.4283C5.71419 15.7439 5.96988 15.9998 6.28548 16C6.37424 16 6.4618 15.9794 6.54118 15.9397L9.96969 14.2255C10.1634 14.1287 10.2858 13.9306 10.2857 13.714V8.82557L15.8108 3.85423C15.9314 3.74565 16.0002 3.59086 15.9999 3.42851V0.57143C15.9999 0.255833 15.744 0 15.4284 0ZM14.857 3.17422L9.33197 8.14556C9.2113 8.25414 9.14256 8.40893 9.14283 8.57128V13.3609L6.85715 14.5037V8.57128C6.85711 8.40936 6.78837 8.25505 6.66801 8.14673L1.14295 3.17422V1.14283H14.857V3.17422Z" />
  // </svg>
);

// forwardRef обязателен: antd Popover клонирует триггер и вешает на него ref,
// а функциональный компонент без forwardRef узел не отдаст — поповер не
// спозиционируется. Semantic такого не требовал (доставал узел через findDOMNode).
export const Label = React.forwardRef<
  HTMLDivElement,
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    columnKey: Column;
  }
>((props, ref) => {
  const { onClick, columnKey, className, ...rest } = props;
  const _onClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation();
    onClick?.(e);
  };

  const activeFilters = useSelector(getActiveFilters);

  const af = activeFilters[columnKey];

  const active = af !== undefined && !conditionIsEmpty(af);
  return (
    <div
      ref={ref}
      onClick={_onClick}
      {...rest}
      // className приходит от Popover (ant-popover-open у открытого) — не теряем.
      className={['ch-file-manager__filter-div', active && 'active', className]
        .filter(Boolean)
        .join(' ')}
    >
      <FilterIcon />
    </div>
  );
});
Label.displayName = 'FilterLabel';
